import { render } from "./elem.vue?vue&type=template&id=13d2b536"
import script from "./elem.vue?vue&type=script&lang=js"
export * from "./elem.vue?vue&type=script&lang=js"

import "./elem.vue?vue&type=style&index=0&id=13d2b536&scope=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__